module.exports = __webpack_public_path__ + "img/type.3950b751.svg";